import './map-section.scss';
import 'assets/scripts/maps';
export default (() => {
  $('.maps').maps({
    map: {
      disableDefaultUI: true,
      zoomControl: true
    },
    infobox: {
      closeBoxMargin: '-15px -15px 0px 0px',
      closeBoxURL: 'https://www.google.com/intl/en_us/mapfiles/close.gif'
    }
  });
});